import * as Actions from './actions';

export default {
  namespaced: true,
  state: {
    defaultInfracaoCodigo: '',
    defaultInfracaoDesdobramento: '',
    defaultCondutorSituacao: '',
    defaultObservacao: '',
  },
  getters: {},
  mutations: {},
  actions: {
    ...Actions,
  },
};
